import FieldDropdown from "../../../generic/dropdown/dropdown"
import FieldConfig from "../../../proto/field-config"
import FieldAgileReportDate_FormElement from "./render/form-element"
import FieldAgileReportDate_InlineEditable from "./render/inline-editable"
import FormManager from "../../../../gd-form/common/form-manager"
import FieldAgileReportDate_FormElementView from "./render/form-element-view";

const debug = false
// const debug = "FieldAgileReportDate"

export default class FieldAgileReportDate extends FieldDropdown {

    constructor(config:FieldConfig) {
        config.showMenuMore = false

        super(config);

        // special
        this.options            = []

        this.options.push({value: 7,    label: 'Last 7 days'})
        this.options.push({value: 14,   label: 'Last 14 days'})
        this.options.push({value: 30,   label: 'Last 30 days'})
        this.options.push({value: 90,   label: 'Last 90 days'})
        this.options.push({value: null, label: 'Custom date range'})

        this.noValueOption      = false
        this.isSearchable       = false

        this.renderComponents.inlineEditable  = FieldAgileReportDate_InlineEditable
        this.renderComponents.formElement     = FieldAgileReportDate_FormElement
        this.renderComponents.formElementView = FieldAgileReportDate_FormElementView

    }

    isValueValid(value:any): any {
        return value.isValid()
    }

    validator(value: any, formManager: FormManager): boolean | string {
        return this.isValueValid(value) ? true : '{0} is required'.f(this.label)
    }
}
